var AT_AjaxSearch = {
  debounceTimeout: null,

  ajaxProductItems: function (input_element, result_wrapper, result_element) {
    var search_url = '/search',
      _keyword = input_element.val();

    if (_keyword.length >= 2) {
      jQuery('.searchbox').addClass("s-loading");

      jQuery.ajax({
        type: 'GET',
        data: {
          q: "*" + _keyword + "* -tag:delete -tag:RM -tag:persistente",
          type: "product",
          view: "json",
        },
        dataType: "json",
        url: search_url,
        complete: function(){
          jQuery('.searchbox').removeClass("s-loading");
        },
        success: function (json_reponse) {
          result_element.html(" ");

          if (json_reponse.length > 0) {
            for (var i = 0; i < json_reponse.length; i++) {
              var item = json_reponse[i],
                title = item.title,
                price = item.price,
                handle = item.handle,
                image = item.featured_image,
                compare_price = item.has_compare_price ? '<span class="price-compare">' + item.compare_price + '</span>' : "",
                compare_class = item.has_compare_price ? "price-sale" : "price",
                price_class = item.available ? "" : " sold-out ",
                price = item.available ? item.price : item.out_stock_nofication,
                markedString = title.replace(new RegExp('(' + _keyword + ')', 'gi'), '<span class="marked">$1</span>'),
                template = '<li class="result-item just-added" style="display:none;">' +
                '<a class="search-item-img" href="' + handle + '">' +
                '<img style="max-width: 60px; float: left;" src="' + image + '" />' +
                '</a>' +
                '<a class="search-item-title" href="' + handle + '">' + markedString + '</a>' +
                compare_price +
                '<span class="' + compare_class + price_class + '">' + price + '</span>' +
                '</li>';

              result_element.append(template);
              setTimeout(function () {
                result_element.children('li.result-item.just-added').removeClass('just-added').slideDown(600);
              }, 300);
            }

            if ($('.result-ajax-search-' + device + ' .search-results-' + device + ' li').length) {
              $('.result-ajax-search-' + device).show();
              currenciesCallbackSpecial('.result-ajax-search-' + device + ' span.money');
            }
          } else {
            result_element.html('<li class="result-item"><p>No hay resultados para tu búsqueda.</p></li>');
            $('.result-ajax-search-' + device).show();
          }
        }
      });
    } else {
      result_element.html('<li><p>Debes ingresar a lo menos 2 caracteres.</p></li>');
    }
  },

  handleSearchInput: function (input_element, result_wrapper, result_element) {
    var _keyword = input_element.val(),
      ajax_search = this;

    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    this.debounceTimeout = setTimeout(function () {
      ajax_search.ajaxProductItems(input_element, result_wrapper, result_element);
    }, 300); // 300ms debounce delay
  },

  ajaxSearch: function (bc_search_config) {
    var search_input_id = bc_search_config.search_input || '#bc-product-search',
      wrapper_id = bc_search_config.result_wrapper || '.result-ajax-search-' + device,
      result_id = bc_search_config.result_element || '.search-results-' + device,
      ajax_search = this;

    $(document).on('keyup', search_input_id, function (event) {
      if (event.which !== 13) { // Exclude Enter key to prevent immediate search on Enter
        ajax_search.handleSearchInput($(this), $(wrapper_id), $(result_id));
      }
    });
  },

  init: function (bc_search_config) {
    this.ajaxSearch(bc_search_config);
  }
};

$(document).ready(function () {
  device = $(window).width() <= 768 ? "mobile" : "desktop";

  AT_AjaxSearch.init({
    "search_input": "#bc-product-search",
    "result_wrapper": ".result-ajax-search-" + device,
    "result_element": ".search-results-" + device,
    "strictly_mode": 0
  });

  AT_AjaxSearch.init({
    "search_input": "#bc-product-search-bann",
    "result_wrapper": ".result-ajax-search-bann-desktop",
    "result_element": ".search-results-bann",
    "strictly_mode": 0
  });
});

$(window).on('resize', function () {
  device = $(window).width() <= 768 ? "mobile" : "desktop";
});